export default function PhotoPreviewGrid({ photos, removePhoto }) {
  if (!photos.length) return null;

  return (
    <div className="photo-preview-grid">
      {photos.map((photo, index) => (
        <div className="photo-thumb" key={`${photo.name}-${index}`}>
          <img src={photo.preview} alt={`Vista previa de ${photo.name}`} />

          <button
            type="button"
            onClick={() => removePhoto(index)}
            className="photo-delete"
          >
            ×
          </button>
        </div>
      ))}
    </div>
  );
}
